import React from 'react';
import { ListItem, ListItemText, MenuItem, Menu } from '@material-ui/core';
import { connect } from 'react-redux';
import * as DevToolActions from 'app/actions/dev-tool/actions';

interface CreditPullTestCase {
  firstName             : string;
  middleName            : string;
  lastName              : string;
  livingPropertyStreet  : string;
  livingPropertyCity    : string;
  livingPropertyState   : string;
  livingPropertyZip     : string;
  ssn                   : string;
  married?              : string;
  hasCoBorrower?        : string;
  coBorrowerFirstName?  : string;
  coBorrowerMiddleName? : string;
  coBorrowerLastName?   : string;
  coBorrowerDateOfBirth?: string;
  coBorrowerSameAddress?: string;
  coBorrowerSsn?        : string;
  /**
   * Flag used to show that this record is a test case.
   * Since the credit pull test cases don't use valid addresses,
   * we want to let the address validation API know to ignore these
   * records when they come through.
   *
   * @type {true}
   * @memberof CreditPullTestCase
   */
  isTestCase            : true;
}

const marisol: CreditPullTestCase = {
  firstName           : 'Marisol',
  middleName          : 'L',
  lastName            : 'Testcase',
  livingPropertyStreet: '220 Locust Ave',
  livingPropertyCity  : 'Anthill',
  livingPropertyState : 'MO',
  livingPropertyZip   : '65488',
  ssn                 : '000000001',
  hasCoBorrower       : 'No',
  isTestCase           : true,
};

const david: CreditPullTestCase = {
  firstName           : 'David',
  middleName          : 'C',
  lastName            : 'Testcase',
  livingPropertyStreet: '504 Grandview St Unit 2',
  livingPropertyCity  : 'Anthill',
  livingPropertyState : 'MO',
  livingPropertyZip   : '65488',
  ssn                 : '000000002',
  hasCoBorrower       : 'No',
  isTestCase           : true,
};

const ann: CreditPullTestCase = {
  firstName           : 'Ann',
  middleName          : '',
  lastName            : 'Gage',
  livingPropertyStreet: '123 Rocky Rd',
  livingPropertyCity  : 'Anthill',
  livingPropertyState : 'MO',
  livingPropertyZip   : '65488',
  ssn                 : '000000003',
  hasCoBorrower       : 'No',
  isTestCase           : true,
};

const douglas: CreditPullTestCase = {
  firstName           : 'Douglas',
  middleName          : 'D',
  lastName            : 'Abt',
  livingPropertyStreet: '1601 N Hollywood Way Unit K',
  livingPropertyCity  : 'Burbank',
  livingPropertyState : 'CA',
  livingPropertyZip   : '91505',
  ssn                 : '666976523',
  hasCoBorrower       : 'No',
  isTestCase           : true,
};

const billAndBeth: CreditPullTestCase = {
  firstName            : 'Bill',
  middleName           : 'C',
  lastName             : 'Testcase',
  livingPropertyStreet : '8842 48th Ave',
  livingPropertyCity   : 'Anthill',
  livingPropertyState  : 'MO',
  livingPropertyZip    : '65488',
  ssn                  : '000000015',
  married              : 'Married',
  hasCoBorrower        : 'Yes',
  coBorrowerFirstName  : 'Beth',
  coBorrowerMiddleName : 'C',
  coBorrowerLastName   : 'Testcase',
  coBorrowerDateOfBirth: '1980-01-01T05:00:00.000Z',
  coBorrowerSameAddress: 'Yes',
  coBorrowerSsn        : '000000016',
  isTestCase           : true,
};

const marisolAndBeth: CreditPullTestCase = {
  firstName             : 'Marisol',
  middleName            : 'L',
  lastName              : 'Testcase',
  livingPropertyStreet  : '220 Locust Ave',
  livingPropertyCity    : 'Anthill',
  livingPropertyState   : 'MO',
  livingPropertyZip     : '65488',
  ssn                   : '000000001',
  hasCoBorrower         : 'Yes',
  coBorrowerFirstName   : 'Beth',
  coBorrowerMiddleName  : 'C',
  coBorrowerLastName    : 'Testcase',
  coBorrowerDateOfBirth : '1980-01-01T05:00:00.000Z',
  coBorrowerSameAddress : 'Yes',
  coBorrowerSsn         : '000000016',
  isTestCase            : true,
};

const sarah: CreditPullTestCase = {
  firstName           : 'Sarah',
  middleName          : 'D',
  lastName            : 'Testcase',
  livingPropertyStreet: '171 Glenwood Dr',
  livingPropertyCity  : 'Anthill',
  livingPropertyState : 'MO',
  livingPropertyZip   : '65488',
  ssn                 : '000000008',
  hasCoBorrower       : 'No',
  isTestCase           : true,
};

const nicole: CreditPullTestCase = {
  firstName            : 'Nicole',
  middleName           : '',
  lastName             : 'Testcase',
  livingPropertyStreet : '171 Glenwood Dr',
  livingPropertyCity   : 'Anthill',
  livingPropertyState  : 'MO',
  livingPropertyZip    : '65488',
  ssn                  : '000000007',
  hasCoBorrower        : 'No',
  isTestCase           : true,
};

const melinda: CreditPullTestCase = {
  firstName            : 'Melinda',
  middleName           : '',
  lastName             : 'Testcase',
  livingPropertyStreet : '171 Glenwood Dr',
  livingPropertyCity   : 'Anthill',
  livingPropertyState  : 'MO',
  livingPropertyZip    : '65488',
  ssn                  : '000000010',
  hasCoBorrower        : 'No',
  isTestCase           : true,
};

const carlos: CreditPullTestCase = {
  firstName            : 'Carlos',
  middleName           : '',
  lastName             : 'Testcase',
  livingPropertyStreet : '171 Glenwood Dr',
  livingPropertyCity   : 'Anthill',
  livingPropertyState  : 'MO',
  livingPropertyZip    : '65488',
  ssn                  : '000000006',
  hasCoBorrower        : 'No',
  isTestCase           : true,
};

const james: CreditPullTestCase = {
  firstName            : 'James',
  middleName           : '',
  lastName             : 'Testcase',
  livingPropertyStreet : '171 Glenwood Dr',
  livingPropertyCity   : 'Anthill',
  livingPropertyState  : 'MO',
  livingPropertyZip    : '65488',
  ssn                  : '000000012',
  hasCoBorrower        : 'No',
  isTestCase           : true,
};

const beth: CreditPullTestCase = {
  firstName            : 'Beth',
  middleName           : 'C',
  lastName             : 'Testcase',
  livingPropertyStreet : '8842 48th Ave',
  livingPropertyCity   : 'Anthill',
  livingPropertyState  : 'MO',
  livingPropertyZip    : '65488',
  ssn                  : '000000016',
  hasCoBorrower        : 'No',
  isTestCase           : true,
};

const donna: CreditPullTestCase = {
  firstName            : 'Donna',
  middleName           : 'Freeman',
  lastName             : 'Testcase',
  livingPropertyStreet : '13414 Hearth Stone Dr',
  livingPropertyCity   : 'Anthill',
  livingPropertyState  : 'MO',
  livingPropertyZip    : '65488',
  ssn                  : '000000020',
  hasCoBorrower        : 'No',
  isTestCase           : true,
};

const donnaAndMarisol: CreditPullTestCase = {
  firstName            : 'Donna',
  middleName           : 'Freeman',
  lastName             : 'Testcase',
  livingPropertyStreet : '13414 Hearth Stone Dr',
  livingPropertyCity   : 'Anthill',
  livingPropertyState  : 'MO',
  livingPropertyZip    : '65488',
  ssn                  : '000000020',
  hasCoBorrower        : 'Yes',
  isTestCase           : true,
  coBorrowerFirstName  : 'Marisol',
  coBorrowerMiddleName : 'L',
  coBorrowerLastName   : 'Testcase',
  coBorrowerSsn        : '000000001',
};

const jamesLowCredit: CreditPullTestCase = {
  firstName            : 'James',
  middleName           : '',
  lastName             : 'Magoo',
  livingPropertyStreet : '171 Glenwood Dr',
  livingPropertyCity   : 'Anthill',
  livingPropertyState  : 'MO',
  livingPropertyZip    : '65488',
  ssn                  : '100000012',
  hasCoBorrower        : 'No',
  isTestCase           : true,
};

const elon: CreditPullTestCase = {
  firstName            : 'Elon',
  middleName           : '',
  lastName             : 'Tusk',
  livingPropertyStreet : '1234 Main Street',
  livingPropertyCity   : 'Royal Oak',
  livingPropertyState  : 'MI',
  livingPropertyZip    : '48067',
  ssn                  : '000000021',
  hasCoBorrower        : 'No',
  isTestCase           : true,
};

const options = [
  { label: 'No Test Case Selected', value: {} },
  { label: 'Beth - 765 Score/Two Real Estate ', value: beth },
  { label: 'Marisol - 745 Score/No Real Estate', value: marisol },
  { label: 'Donna - 710 Score/Two Real Estate', value: donna },
  { label: 'James - 697 Score/Two Real Estate', value: james },
  { label: 'David - 668 Score/One Real Estate', value: david },
  { label: 'Melinda - 509 Score/Past Due Accounts', value: melinda },
  { label: 'Nicole - 509 Score/Past Due Accounts', value: nicole },
  { label: 'Sarah - 460 Score/Past Due Accounts', value: sarah },
  { label: 'Carlos - 492 Score/Bankruptcy within 2 Years', value: carlos },
  { label: 'Ann - Frozen Credit Report', value: ann },
  { label: 'Douglas - No Record Found', value: douglas },
  { label: 'Marisol & Beth - 745 Score', value: marisolAndBeth },
  { label: 'Bill & Beth - 669 Score/No Real Estate', value: billAndBeth },
  { label: 'Donna & Marisol - 710 Score/Two Real Estate', value: donnaAndMarisol },
  { label: 'James - 300 Score/2 RE - Mock Only', value: jamesLowCredit },
  { label: 'Elon - 577 Score/Two Real Estate', value: elon },
];

class DevCreditPull extends React.Component<any, any> {
  state = {
    anchorEl     : null,
    selectedIndex: 0,
  };

  handleClickListItem = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
    this.props.setCreditPullTestCase(options[index].value);
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <React.Fragment>
        <ListItem
          button
          aria-haspopup = 'true'
          aria-controls = 'lock-menu'
          aria-label    = 'Soft Credit Pull Test Case'
          onClick       = {this.handleClickListItem}
        >
          <ListItemText
            primary   = 'Soft Credit Pull Test Case'
            secondary = {options[this.state.selectedIndex].label}
          />
        </ListItem>
        <Menu
          id       = 'lock-menu'
          anchorEl = {anchorEl}
          open     = {Boolean(anchorEl)}
          onClose  = {this.handleClose}
        >
          {options.map((option, index) => {
            return (
              <MenuItem
                disabled = {index === 0}
                key      = {option.label}
                onClick  = {event => this.handleMenuItemClick(event, index)}
                selected = {index === this.state.selectedIndex}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </Menu>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = DevToolActions;

export default connect(
  null,
  mapDispatchToProps,
)(DevCreditPull);
